export default __webpack_public_path__ + "static/media/sample2.1be65aa0.mp4";